import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const StyledLink = styled(Link)`
  position: ${({ position }) => position ? position : 'absolute'};
  display:flex;
  justify-content:center;
  align-items:center;
  text-decoration:none;
  background-color:transparent;
  color:white;
`